import PortifolioList from "../components/portifolio/PortifolioList";

const Portifolio = () => {
  return (
    <div className="pt-20 max-w-7xl mx-auto px-4">
      <PortifolioList />
    </div>
  );
};

export default Portifolio;
